import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { URL } from "../../Redux/common/url";

function Cmimg({ url, altkey, index }) {
  const [isLoaded, setIsLoaded] = useState(false);
  console.log(isLoaded);
  console.log(index);
  console.log(altkey);

  return (
    <div>
      <img
        src={url}
        alt={altkey}
        className={`blur-image ${isLoaded ? "hide" : ""}`}
        style={{
          filter: "blur(20px)",
          transition: "opacity 0.3s ease-in-out",
          opacity: isLoaded ? 0 : 1,
        }}
      />

      <LazyLoadImage
        alt={altkey}
        // width={imageWidth}
        // height={imageHeight}
        delayTime={300}
        onLoad={() => setIsLoaded(true)}
        style={{
          // Hide until loaded
          transition: "opacity 0.1s ease-in-out",
          opacity: isLoaded ? 1 : 0,
        }}
        src={url} // use normal <img> attributes as props
      />
    </div>
  );
}

export default Cmimg;
